import { useState, useEffect, useMemo } from "react";
import {
  Box,
  TextField,
  InputAdornment,
  Typography,
  Paper,
  Grid,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions, Button,
  IconButton,
  Tooltip,
  Modal,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import { useGetIngresosMasivos, useIngresoPaciente } from "../../../Services/IngresoPaciente";
import { useGetSucursal } from "../../../Services/Sucursales";
import { FormatRut } from "../../FuncionesGenerales/Rut"; // ✅ Importas tu formateador
import { formatCLP } from "../../FuncionesGenerales/FormatoCLP";
import { DiseñoDataGrid } from "../../FuncionesGenerales/DataGrid";
import { FaHistory } from "react-icons/fa";
import { Texto, buttonGuardar, SubTitulo, InputDescripcion, Input, inputFecha, modalStyle, InputBuscador, buttonCancelar, buttonAtras } from "../../../Layouts/CustomStyles";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { FaTrashCan } from "react-icons/fa6";
import { useGetProfesional } from "../../../Services/Profesional";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { useGetPrevision } from "../../../Services/Prevision";

export const BusquedaPaciente = ({ actualizarTabla }) => {
    const { Prevision} = useGetPrevision();
  const { historialPacientes,  loadingsIngresos,  refetchHP, refetchIP } = useGetIngresosMasivos();
  const { editarIngresoPaciente, eliminarIngresoPaciente } = useIngresoPaciente();
  const { sucursales, loadings: loadSucursales, error: errorSucursales } = useGetSucursal();
  const { profesional } = useGetProfesional();
  const [openHistorial, setOpenHistorial] = useState(false);
  const [historialSeleccionado, setHistorialSeleccionado] = useState([]);
  const [pacienteSeleccionado, setPacienteSeleccionado] = useState(null);
  const [openObs, setOpenObs] = useState(false);
  const [obsSeleccionada, setObsSeleccionada] = useState("");
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedIngreso, setSelectedIngreso] = useState(null);
  const [successAlertOpen, setSuccessAlertOpen] = useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = useState(false);
  const [enviandoAlert, setEnviandoAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const profesionalesFiltrados = profesional.filter((p) => {
    // Excluir los del área 1 siempre
    if (p.id_area_servicio === "1") return false;

    // Si seleccionó "Mostrar todos"
    if (selectedIngreso?.kine === "TODOS") return true;

    // Si NO selecciona sucursal → mostrar todos
    if (!selectedIngreso?.branch_id) return true;

    // Filtrar por sucursal
    return (
        p.sucursal_uno === selectedIngreso.branch_name ||
        p.sucursal_dos === selectedIngreso.branch_name
    );
});


  const [busqueda, setBusqueda] = useState({
    rut: "", nombre: "", episodio: ""
  });

  useEffect(() => {
    refetchIP(); // 🔄 Vuelve a cargar los datos
  }, [actualizarTabla]);

  const handleOpenHistorial = (row) => {
    setHistorialSeleccionado(row.pagos_deudor || []);
    setPacienteSeleccionado(row.nombre_paciente);
    setOpenHistorial(true);
  };


  const handleCloseHistorial = () => {
    setOpenHistorial(false);
  };
  const capitalize = (str) => {
    if (!str) return "";
    return str
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase()); // Convierte la primera letra de cada palabra
  };

  useEffect(() => {
    // Si hay algún valor de búsqueda, refetch
    if (busqueda.rut || busqueda.nombre || busqueda.episodio || busqueda.anio || busqueda.mes || busqueda.dia) {
      refetchHP(busqueda); // enviar todo el objeto busqueda al backend
    }
  }, [busqueda]);

  // ✅ Efecto: si el RUT tiene más de 6 caracteres, dispara la búsqueda
  useEffect(() => {
    if (busqueda.rut.replace(/\D/g, "").length >= 6) {
      refetchHP(busqueda.rut);
    }
  }, [busqueda.rut]);



  const pacientesNormalizados = useMemo(() => {
    return historialPacientes.map(p => ({
      ...p,
      episodio: p.episodio ?? "",           // si viene null → ""
      pagos_deudor: p.pagos_deudor ?? []    // si no existe → []
    }));
  }, [historialPacientes]);

  // --- Filtro ---
  const pacientesFiltrados = useMemo(() => {
    return pacientesNormalizados.filter((p) => {
      const fecha = new Date(p.fecha + "T00:00");
      const anio = fecha.getFullYear().toString();
      const mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
      const dia = fecha.getDate().toString().padStart(2, "0");

      const rutPaciente = (p.rut || "").replace(/\./g, "").replace(/-/g, "").toLowerCase();
      const rutBusqueda = (busqueda.rut || "").replace(/\./g, "").replace(/-/g, "").toLowerCase();

      const nombrePaciente = (p.nombre_paciente || "").toLowerCase();
      const nombreBusqueda = (busqueda.nombre || "").toLowerCase();

      const episodioPaciente = (p.episodio || "").toString().trim().toLowerCase();
      const episodioBusqueda = (busqueda.episodio || "").toString().trim().toLowerCase();

      return (
        (!rutBusqueda || rutPaciente.includes(rutBusqueda)) &&
        (!nombreBusqueda || nombrePaciente.includes(nombreBusqueda)) &&
        (!episodioBusqueda || episodioPaciente.includes(episodioBusqueda)) &&
        (!busqueda.anio || anio === busqueda.anio) &&
        (!busqueda.mes || mes === busqueda.mes.padStart(2, "0")) &&
        (!busqueda.dia || dia === busqueda.dia.padStart(2, "0"))
      );
    });
  }, [busqueda, pacientesNormalizados]);



  const columns = [
    { field: "fecha", headerName: "Fecha", width: 120 },
    { field: "rut", headerName: "RUT", width: 140, renderCell: (params) => FormatRut(params.value) },
    {
      field: "nombre_paciente",
      headerName: "Nombre Paciente",
      width: 180,
      renderCell: (params) => capitalize(params.value)
    },
    {
      field: "episodio",
      headerName: "Episodio",
      width: 180,
      renderCell: (params) => {
        const episodio = params.row.episodio ?? "—";
        const tienePagos = params.row.pagos_deudor?.length > 0;

        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <span>{episodio}</span>

            {tienePagos && (
              <Box
                onClick={() => handleOpenHistorial(params.row)}
                sx={{
                  cursor: "pointer",
                  backgroundColor: "#77c3c571",
                  borderRadius: "50%",
                  padding: "6px",
                  border: "2px solid #1a73e8",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FaHistory size={25} color="#1a73e8" />
              </Box>
            )}

          </Box>
        );
      },
    },
    {
      field: "prevision",
      headerName: "Previsión",
      width: 120,
      renderCell: (params) => capitalize(params.value)
    },
    {
      field: "estado_paciente",
      headerName: "Estado",
      width: 120,
      renderCell: (params) => capitalize(params.value)
    },
    { field: "n_sesiones", headerName: "Sesiones", width: 120 },
    { field: "estado_pago", headerName: "Estado Pago", width: 120 },
    { field: "fecha_pago", headerName: "Fecha de Pago", width: 120 },
    { field: "monto", headerName: "Monto", width: 120, renderCell: (params) => formatCLP(params.value) },
    {
      field: "observaciones",
      headerName: "Observaciones",
      width: 130,
      renderCell: (params) => {
        const tieneObs =
          params.row.observaciones &&
          params.row.observaciones.trim() !== "";

        return tieneObs ? (
          <Tooltip title="Ver observación">
            <IconButton
              onClick={() => {
                setObsSeleccionada(params.row.observaciones);
                setOpenObs(true);
              }}
              sx={{ color: "#2a8d74" }}
            >
              <ChatBubbleOutlineIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Typography sx={{ color: "#777", fontSize: "14px" }}>—</Typography>
        );
      },
    },

    {
      field: "acciones",
      headerName: "Acción",
      width: 150,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              width: 150,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <button className="edit-button" onClick={() => handleOpenEdit(params.row)}>
              <svg className="edit-svgIcon" viewBox="0 0 512 512">
                <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
              </svg>
            </button>
            <button className="delete-button" onClick={() => handleOpenDelete(params.row)}>
              <FaTrashCan className="delete-svgIcon" />
            </button>
          </Box>
        );
      },
    },
  ];

  const handleOpenEdit = (row) => {
    setSelectedIngreso(row);
    setOpenEdit(true);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
    setSelectedIngreso(null);
  };

  const handleEditarIngreso = async () => {
    if (!selectedIngreso) return;

    try {
      setEnviandoAlert(true);

      const payload = {
        fecha: selectedIngreso.fecha,
        fecha_pago: selectedIngreso.fecha_pago,
        rut: selectedIngreso.rut,
        estado_pago: selectedIngreso.estado_pago,
        nombre_paciente: selectedIngreso.nombre_paciente,
        estado_paciente: selectedIngreso.estado_paciente,
        prevision: selectedIngreso.prevision,
        medico_tratante: selectedIngreso.medico_tratante,
        branch_id: selectedIngreso.branch_id,
        kine: selectedIngreso.kine,
        n_sesiones: selectedIngreso.n_sesiones,
        episodio: selectedIngreso.episodio,
        monto: selectedIngreso.monto,
        valor: selectedIngreso.monto, // ⚠️ sincronizado
        observaciones: selectedIngreso.observaciones,
      };


      await editarIngresoPaciente(selectedIngreso.id, payload);

      setAlertMessage("Ingreso actualizado correctamente ✅");
      setSuccessAlertOpen(true);
      refetchIP(); // recarga la lista
      refetchHP();
      handleCloseEdit(); // cierra el modal
    } catch (error) {
      setAlertMessage(`Error al actualizar: ${error}`);
      setErrorAlertOpen(true);
    } finally {
      setEnviandoAlert(false);
    }
  };

  const handleOpenDelete = (row) => {
    setSelectedIngreso(row);
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setSelectedIngreso(null);
  };

  const handleEliminarIngreso = async () => {
    if (!selectedIngreso) return;

    try {
      setEnviandoAlert(true);

      await eliminarIngresoPaciente(selectedIngreso.id); // llama al API DELETE

      setAlertMessage("Ingreso eliminado correctamente ✅");
      setSuccessAlertOpen(true);
      refetchIP(); // recarga la lista
      refetchHP();
      handleCloseDelete();
    } catch (error) {
      setAlertMessage(`Error al eliminar: ${error}`);
      setErrorAlertOpen(true);
    } finally {
      setEnviandoAlert(false);
    }
  };


  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" sx={{ mb: 2, fontFamily: "Poppins", fontWeight: 600, color: '#585857' }}>
        Historial de Paciente
      </Typography>

      {/* --- Filtros --- */}
      <Paper sx={{ p: 2, mb: 3, borderRadius: 2, backgroundColor: "#fafafa" }}>
        <Grid container spacing={2}>
          {[
            { name: "rut", label: "Buscar por RUT" },
            { name: "nombre", label: "Buscar por Nombre" },
            { name: "episodio", label: "Buscar por Episodio" },
          ].map((f) => (
            <Grid item xs={12} sm={6} md={4} key={f.name}>
              <TextField
                fullWidth
                size="small"
                label={f.label}
                name={f.name}
                value={busqueda[f.name]}
                onChange={(e) => {
                  let value = e.target.value;
                  if (f.name === "rut") {
                    // ✅ Aplicar formato de RUT
                    value = FormatRut(value);
                  }
                  setBusqueda({ ...busqueda, [f.name]: value });
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#777" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiInputBase-input": { fontFamily: "Poppins" },
                  "& .MuiInputLabel-root": { fontFamily: "Poppins" },
                }}
              />
            </Grid>
          ))}



        </Grid>
      </Paper>

      {/* --- Tabla --- */}
      <Paper sx={{ borderRadius: 2, p: 1 }}>
        {loadingsIngresos ? (
          <Box sx={{ display: "flex", justifyContent: "center", height: 300 }}>
            <CircularProgress />
          </Box>
        ) : (
          <div style={{ height: 400, width: "100%" }}>
            <DataGrid
              slots={{ noRowsOverlay: DiseñoDataGrid }}
              rows={pacientesFiltrados.map((p, i) => ({ id: i + 1, ...p }))}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5]}
              getRowClassName={(params) => {
                const estado = params.row.estado_pago?.toUpperCase();
                if (estado === "NO PAGO") return "nopagado";
                if (estado === "LIBERADO") return "liberado";
                if (estado === "PROCESO") return "proceso"; // 🔶 nuevo
                return "";
              }}
              sx={{
                fontFamily: "Poppins, sans-serif",
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#f0f0f0",
                  fontWeight: 600,
                },
                "& .nopagado": {
                  bgcolor: "#ea838364", // rojo clarito
                  color: "#5b1111",     // texto rojo oscuro
                  "&:hover": { bgcolor: "#ea8383", color: "#fff" },
                },
                "& .liberado": {
                  bgcolor: "#f1a7677f", // naranja clarito
                  color: "#b35400",     // texto naranja oscuro
                  "&:hover": { bgcolor: "#efa330ff", color: "#fff" },
                },
                "& .proceso": {
                  bgcolor: "#fff3b0", // amarillo clarito
                  color: "#8f8303ff",   // texto amarillo oscuro
                  "&:hover": { bgcolor: "#b69308ff", color: "#ffffffff" }, // más intenso al pasar el mouse
                },
              }}
            />



          </div>
        )}
      </Paper>
      <Dialog open={openHistorial} onClose={handleCloseHistorial} fullWidth maxWidth="sm" scroll="paper"   >
        <DialogTitle
          sx={{
            color: '#585857',
            fontFamily: 'Poppins',
            fontWeight: '500',
            textTransform: 'capitalize',
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,     // espacio entre ícono y texto
          }}
        >
          <FaHistory size={22} color="#1a73e8" />
          Historial episodios
        </DialogTitle>
        <DialogTitle
          sx={{
            color: '#585857',
            fontFamily: 'Poppins',
            fontWeight: '500',
            textTransform: 'capitalize',
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,     // espacio entre ícono y texto
          }}
        >
          {pacienteSeleccionado}
        </DialogTitle>


        <DialogContent dividers>
          {historialSeleccionado.length === 0 ? (
            <p>No tiene registros de pago.</p>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {historialSeleccionado.map((pago) => (
                <Box
                  key={pago.id}
                  sx={{
                    padding: 2,
                    borderRadius: 2,
                    border: "1px solid #ddd",
                    background: "#fafafa",
                  }}
                >
                  <p><strong>Fecha:</strong> {pago.fecha_pago}</p>
                  <p><strong>Monto pagado:</strong> {formatCLP(pago.monto_pagado)}</p>
                  <p><strong>Sesiones pagadas:</strong> {pago.sesiones_pagadas}</p>
                  <p><strong>Episodios:</strong> {pago.episodios || "—"}</p>
                </Box>
              ))}
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button sx={buttonCancelar} onClick={handleCloseHistorial}>Cerrar</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openEdit} onClose={handleCloseEdit} fullWidth maxWidth="sm">
        <DialogTitle sx={Texto}>Editar Ingreso</DialogTitle>
        <DialogContent>
          {/* Aquí puedes poner un formulario con los campos de `selectedIngreso` */}
          <Box sx={{ display: "flex", mt: 2, gap: 2, mb: 2 }}>
            {/* Fecha */}
            <TextField
              sx={inputFecha}
              label="Fecha"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={selectedIngreso?.fecha || ""}
              onChange={(e) =>
                setSelectedIngreso({ ...selectedIngreso, fecha: e.target.value })
              }
              fullWidth
            />
            <TextField
              sx={inputFecha}
              label="Fecha de Pago"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={selectedIngreso?.fecha_pago || ""}
              onChange={(e) =>
                setSelectedIngreso({ ...selectedIngreso, fecha_pago: e.target.value })
              }
              fullWidth
            />
          </Box>
           <Box sx={{ mb: 2 }}>
                                  <FormControl fullWidth sx={Input}>
                                      <InputLabel id="estado-pago-label">Estado de pago</InputLabel>
                                      <Select
                                          labelId="estado-pago-label"
                                          name="estado_pago"
                                          value={selectedIngreso?.estado_pago || ""} // <-- esto debe ser exactamente lo que hay en la BD
                                          onChange={(e) =>
                                              setSelectedIngreso({ ...selectedIngreso, estado_pago: e.target.value })
                                          }
                                          label="Estado de pago"
                                      >
                                          <MenuItem value="">General</MenuItem>
                                          <MenuItem value="PAGADO">Pagado</MenuItem>
                                          <MenuItem value="NO PAGO">No Pagado</MenuItem>
                                          
                                      </Select>
                                  </FormControl>
                              </Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              sx={Input}
              label="RUT"
              fullWidth
              margin="dense"
              value={selectedIngreso?.rut || ""}
              onChange={(e) => {
                const valorFormateado = FormatRut(e.target.value);
                setSelectedIngreso({ ...selectedIngreso, rut: valorFormateado });
              }}
            />
          </Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              sx={Input}
              label="Nombre Paciente"
              fullWidth
              margin="dense"
              value={selectedIngreso?.nombre_paciente || ""}

              onChange={(e) =>
                setSelectedIngreso({ ...selectedIngreso, nombre_paciente: e.target.value })
              }
            />
          </Box>
          <Box sx={{ mb: 2 }}>
            <FormControl fullWidth sx={Input}>
              <InputLabel id="estado-paciente-label">Estado del Paciente</InputLabel>
              <Select
                labelId="estado-paciente-label"
                name="estado_paciente"
                value={selectedIngreso?.estado_paciente || ""} // <-- esto debe ser exactamente lo que hay en la BD
                onChange={(e) =>
                  setSelectedIngreso({ ...selectedIngreso, estado_paciente: e.target.value })
                }
                label="Estado del Paciente"
              >
                <MenuItem value="">General</MenuItem>
                <MenuItem value="INGRESO">Ingreso</MenuItem>
                <MenuItem value="REINGRESO">Reingreso</MenuItem>
                <MenuItem value="EN TERAPIA">Terapia</MenuItem> {/* Si tu BD tiene EN TERAPIA */}
                <MenuItem value="POSTURAGRAFO">Posturagrafo</MenuItem>
                <MenuItem value="PENDIENTE">Pendiente</MenuItem>
              </Select>
            </FormControl>
          </Box>
                                      <Box sx={{ mb: 2 }}>
  <FormControl fullWidth sx={Input}>
    <InputLabel id="prevision-label">Previsión</InputLabel>
    
    <Select
      labelId="prevision-label"
      name="prevision"
     value={selectedIngreso?.prevision || ""} // <-- esto debe ser exactamente lo que hay en la BD
                                onChange={(e) =>
                                    setSelectedIngreso({ ...selectedIngreso, prevision: e.target.value })
                                }
      label="Previsión"
    >
      <MenuItem value="">Seleccionar...</MenuItem>

      {Prevision?.map((item) => (
        <MenuItem key={item.id} value={item.nombre}>
          {item.nombre}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              sx={Input}
              label="Medico Tratante"
              fullWidth
              margin="dense"
              value={selectedIngreso?.medico_tratante || ""}

              onChange={(e) =>
                setSelectedIngreso({ ...selectedIngreso, medico_tratante: e.target.value })
              }
            />
          </Box>
            <Box sx={{ mb: 2 }}>
                        <FormControl fullWidth sx={Input}>
                            <InputLabel id="sucursal-label">Sucursal</InputLabel>
                            <Select
                                labelId="sucursal-label"
                                name="sucursal"
                                value={selectedIngreso?.branch_id || ""}
                                onChange={(e) => {
                                    const selectedId = e.target.value;
                                    const selectedSucursal = sucursales.find(s => s.id === selectedId);

                                    setSelectedIngreso({
                                        ...selectedIngreso,
                                        branch_id: selectedId,
                                        branch_name: selectedSucursal?.name || "",
                                    });
                                }}
                                label="Sucursal"
                            >
                                <MenuItem value="">General</MenuItem>
                                {sucursales?.map((s) => (
                                    <MenuItem key={s.id} value={s.id}>
                                        {s.name}
                                    </MenuItem>
                                ))}
                            </Select>

                        </FormControl>
                    </Box>
                   <Box sx={{ mb: 2 }}>
    <FormControl fullWidth sx={Input}>
        <InputLabel id="profesional-label">Profesional</InputLabel>
        
        <Select
            labelId="profesional-label"
            name="kine"
            value={selectedIngreso?.kine || ""}
            onChange={(e) =>
                setSelectedIngreso({ ...selectedIngreso, kine: e.target.value })
            }
            label="Profesional"
        >
            <MenuItem value="">ver profesional sucursal</MenuItem>
            <MenuItem value="TODOS">Mostrar todos los profesionales</MenuItem>

            {profesionalesFiltrados.map((p) => (
                <MenuItem key={p.id} value={p.nombre}>
                    {p.nombre}
                </MenuItem>
            ))}
        </Select>
    </FormControl>
</Box>

          <Box sx={{ mb: 2 }}>
            <TextField
              sx={Input}
              label="Sesiones"
              fullWidth
              margin="dense"
              value={selectedIngreso?.n_sesiones || ""}

              onChange={(e) =>
                setSelectedIngreso({ ...selectedIngreso, n_sesiones: e.target.value })
              }
            />
          </Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              sx={Input}
              label="Episodio"
              fullWidth
              margin="dense"
              value={selectedIngreso?.episodio || ""}

              onChange={(e) =>
                setSelectedIngreso({ ...selectedIngreso, episodio: e.target.value })
              }
            />
          </Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              sx={Input}

              fullWidth
              margin="dense"
              value={formatCLP(selectedIngreso?.monto)}
              onChange={(e) => {
                // eliminar todo lo que no sea número
                const numericValue = e.target.value.replace(/\D/g, "");

                // actualizar monto y valor simultáneamente
                setSelectedIngreso({
                  ...selectedIngreso,
                  monto: numericValue,
                  valor: numericValue,
                });
              }}
            />

          </Box>
          <Box>
            <TextField
              sx={InputDescripcion}
              label="Observaciones"
              fullWidth
              margin="dense"
              value={selectedIngreso?.observaciones || ""}

              onChange={(e) =>
                setSelectedIngreso({ ...selectedIngreso, observaciones: e.target.value })
              }
            />

          </Box>
          {/* Agrega más campos según necesites */}
        </DialogContent>
        <DialogActions>
          <Button sx={buttonCancelar} onClick={handleCloseEdit}>Cancelar</Button>
          <Button sx={buttonGuardar} onClick={handleEditarIngreso}>
            {enviandoAlert ? "Guardando..." : "Guardar"}
          </Button>

        </DialogActions>
      </Dialog>


      <Dialog open={openDelete} onClose={handleCloseDelete}>
        <DialogTitle sx={Texto}>Eliminar Ingreso</DialogTitle>
        <DialogContent sx={SubTitulo}>
          ¿Estás seguro que quieres eliminar a {selectedIngreso?.nombre_paciente}?
        </DialogContent>
        <DialogActions>
          <Button sx={buttonAtras} onClick={handleCloseDelete}>Cancelar</Button>
          <Button
            onClick={handleEliminarIngreso} // 👈 usamos la función con alert y refetch
            sx={buttonCancelar}
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>



      <Dialog open={openObs} onClose={() => setOpenObs(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontFamily: "Poppins", fontWeight: 600 }}>
          Observación del Paciente
        </DialogTitle>

        <DialogContent>
          <Typography sx={{ fontFamily: "Poppins" }}>
            {obsSeleccionada}
          </Typography>
        </DialogContent>
      </Dialog>


      <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={enviandoAlert}>
        <Box sx={modalStyle}>
          <section style={{ textAlign: "center", padding: "1rem" }}>
            <CircularProgress style={{ color: "#2a8d74" }} />
            <p className="alert-text">Procesando solicitud...</p>
          </section>
        </Box>
      </Modal>
    </Box>
  );
};
